import { DeleteButton } from "./ButtonWithModalForm";

export default DeleteButton;
